<template>
  <course-container title="管理关联视频">
    <div class="wrapper">
      <div class="course-detail">
        <template v-if="courseDetail">
          <div
            class="cover"
            :style="{
              backgroundImage: `url(${courseDetail.detail.coverImagUrl})`
            }"
          ></div>
          <div>
            <div class="course-title">{{ courseDetail.detail.title }}</div>
            <div class="course-author">
              <span>{{ courseDetail.authorInfo.name }}</span> |
              <span>{{ courseDetail.detail.tag }}</span>
              <span class="course-count"
                >共{{ courseDetail.detail.courseCount }}节</span
              >
            </div>
            <div class="course-description">
              {{ courseDetail.detail.description }}
            </div>
          </div>
        </template>
      </div>
      <el-button type="primary" class="button-add" @click="addVideo"
        >添加视频</el-button
      >
      <ul class="video-list">
        <li class="video-row-title">
          <div class="video-col video-col1">序号</div>
          <div class="video-col video-col2">标题</div>
          <div class="video-col video-col3">类型</div>
          <div class="video-col video-col4">文件名称</div>
          <div class="video-col video-col5">创建时间</div>
          <div class="video-col video-col6">时长</div>
          <div class="video-col video-col7">上传状态</div>
          <div class="video-col video-col8">操作</div>
          <div class="video-col video-col9">审核状态</div>
        </li>
        <li v-for="(item, index) in videoList" :key="index" class="video-row">
          <div class="video-col video-col1">第{{ item.index }}节</div>
          <div
            class="video-col video-col2"
            :class="{
              'input-title-label':
                item.applyStatus !== CourseApplyStatus.PendingReview &&
                item.applyStatus !== CourseApplyStatus.Success &&
                item.applyStatus !==
                  CourseApplyStatus.WaitGenerateHighlightSubmit &&
                item.applyStatus !==
                  CourseApplyStatus.WaitGernerateHighlightDone &&
                item.applyStatus !== CourseApplyStatus.Transcoding
            }"
            @click="editTitle(item)"
          >
            {{ item.title }}
          </div>
          <div class="video-col video-col3">
            <div class="video-col_item">片花</div>
            <div class="video-col_item">
              <span :class="{ 'upload-require': !item.contentVideoId }"
                >正片</span
              >
            </div>
          </div>
          <div class="video-col video-col4">
            <div class="video-col_item">
              <p
                :class="{ 'video-col_item-p': item.isHighlightAvailable }"
                @click="
                  item.isHighlightAvailable
                    ? previewAudio(item.highlightVideoId, item.highlightTitle)
                    : null
                "
                :title="item.highlightTitle"
              >
                {{ item.highlightTitle }}
              </p>
            </div>
            <div class="video-col_item">
              <p
                :class="{ 'video-col_item-p': item.isContentAvailable }"
                @click="
                  item.isContentAvailable
                    ? previewAudio(item.contentVideoId, item.contentTitle)
                    : null
                "
                :title="item.contentTitle"
              >
                {{ item.contentTitle }}
              </p>
            </div>
          </div>
          <div class="video-col video-col5">
            <div class="video-col_item">
              {{
                item.highlightUploadTime
                  ? dayjs(item.highlightUploadTime).format(
                      'YYYY-MM-DD HH:mm:DD'
                    )
                  : ''
              }}
            </div>
            <div class="video-col_item">
              {{
                item.contentUploadTime
                  ? dayjs(item.contentUploadTime).format('YYYY-MM-DD HH:mm:DD')
                  : ''
              }}
            </div>
          </div>
          <div class="video-col video-col6">
            <div class="video-col_item">
              {{ (item.highlightVideoId && item.hightlightDuration) || '' }}
            </div>
            <div class="video-col_item">
              {{ (item.contentVideoId && item.duration) || '' }}
            </div>
          </div>
          <div class="video-col video-col7">
            <div class="video-col_item">
              <template v-if="item.highlightProgressText">{{
                item.highlightProgressText
              }}</template>
              <template v-else-if="item.highlightProgress">
                <el-progress
                  class="upload-progress"
                  :percentage="item.highlightProgress * 100"
                  :show-text="false"
                  color="#046bcc"
                  :stroke-width="4"
                ></el-progress>
                {{ Math.round(item.highlightProgress * 100) }}%
              </template>
              <template
                v-else-if="
                  item.applyStatus ===
                    CourseApplyStatus.WaitGenerateHighlightSubmit ||
                    item.applyStatus ===
                      CourseApplyStatus.WaitGernerateHighlightDone
                "
                >自动生成中</template
              >
              <template
                v-else-if="
                  item.isHighlightGenerated &&
                    (item.applyStatus === CourseApplyStatus.Success ||
                      item.applyStatus === CourseApplyStatus.PendingReview)
                "
                >生成成功</template
              >
              <template
                v-else-if="
                  !item.isHighlightGenerated &&
                    (item.applyStatus === CourseApplyStatus.Success ||
                      item.applyStatus === CourseApplyStatus.PendingReview)
                "
                >上传成功</template
              >
            </div>
            <div class="video-col_item">
              <template v-if="item.progressText">{{
                item.progressText
              }}</template>
              <template v-else-if="item.progress">
                <el-progress
                  class="upload-progress"
                  :percentage="item.progress * 100"
                  :show-text="false"
                  color="#046bcc"
                  :stroke-width="4"
                ></el-progress>
                {{ Math.round(item.progress * 100) }}%
              </template>
              <template
                v-else-if="
                  item.applyStatus === CourseApplyStatus.Success ||
                    item.applyStatus === CourseApplyStatus.PendingReview ||
                    item.applyStatus ===
                      CourseApplyStatus.WaitGenerateHighlightSubmit ||
                    item.applyStatus ===
                      CourseApplyStatus.WaitGernerateHighlightDone ||
                    item.applyStatus === CourseApplyStatus.Transcoding
                "
                >上传成功</template
              >
            </div>
          </div>
          <div class="video-col video-col8">
            <div class="video-col_item">
              <aliyun-upload
                v-if="
                  item.applyStatus !== CourseApplyStatus.Success &&
                    item.applyStatus !== CourseApplyStatus.PendingReview &&
                    item.applyStatus !==
                      CourseApplyStatus.WaitGenerateHighlightSubmit &&
                    item.applyStatus !==
                      CourseApplyStatus.WaitGernerateHighlightDone &&
                    item.applyStatus !== CourseApplyStatus.Transcoding
                "
                @startUpload="onStartUpload($event, item.index, true)"
                @uploadProgress="onUploadProgress($event, item.index, true)"
                @uploadComplete="onUploadComplete($event, item.index, true)"
                @uploadCanceled="onUploadCanceled($event, item.index, true)"
                @uploadFileChanged="onUploadFileChanged(item.index, true)"
                @onError="onUploadError"
                :temp="`MP4`"
                :fileType="`video`"
              ></aliyun-upload>
            </div>
            <div class="video-col_item">
              <aliyun-upload
                v-if="
                  item.applyStatus !== CourseApplyStatus.Success &&
                    item.applyStatus !== CourseApplyStatus.PendingReview &&
                    item.applyStatus !==
                      CourseApplyStatus.WaitGenerateHighlightSubmit &&
                    item.applyStatus !==
                      CourseApplyStatus.WaitGernerateHighlightDone &&
                    item.applyStatus !== CourseApplyStatus.Transcoding
                "
                @startUpload="onStartUpload($event, item.index, false)"
                @uploadProgress="onUploadProgress($event, item.index, false)"
                @uploadComplete="onUploadComplete($event, item.index, false)"
                @uploadCanceled="onUploadCanceled($event, item.index, false)"
                @uploadFileChanged="onUploadFileChanged(item.index, false)"
                @onError="onUploadError"
                :temp="`MP4`"
                :fileType="`video`"
              ></aliyun-upload>
            </div>
          </div>
          <div class="video-col video-col9">
            {{ applyStatusTextMap.get(item.applyStatus) }}
          </div>
          <div class="parting-line"></div>
          <el-button
            v-if="
              item.applyStatus !== CourseApplyStatus.Success &&
                item.applyStatus !== CourseApplyStatus.PendingReview &&
                item.applyStatus !==
                  CourseApplyStatus.WaitGenerateHighlightSubmit &&
                item.applyStatus !==
                  CourseApplyStatus.WaitGernerateHighlightDone &&
                item.applyStatus !== CourseApplyStatus.Transcoding
            "
            class="button-apply"
            type="primary"
            :disabled="!item.contentVideoId || highlightUploading"
            :loading="submitApplyLoading"
            @click="submitApply(item.index)"
          >
            提交审核
          </el-button>
        </li>
      </ul>
    </div>
    <el-dialog
      :title="highlightDialog.title"
      :visible.sync="highlightDialog.visible"
      :lock-scroll="false"
      :close-on-click-modal="false"
      :beforeClose="beforeCloseHandle"
    >
      <VideoPlayer
        :playInfo="highlightDialog.playInfo"
        :coverUrl="highlightDialog.coverUrl"
        :status="highlightDialog.status"
      ></VideoPlayer>
    </el-dialog>
  </course-container>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer'
import AliyunUpload from '@/components/AliyunUpload/AliyunUpload'
import CourseContainer from '@/components/AuthorCourse/CourseContainer'
import { getCourseSectionWithApplies, submitApply } from '@/api/authorcourse'
import dayjs from 'dayjs'
import { getResourceDetail, getPlayInfo } from '@/api/resource'
import { getCourseDetail } from '@/api/course'
import { isDef } from '@/assets/js/utils'

const CourseApplyStatus = {
  /**
   * 待审核
   */
  PendingReview: 0,
  /**
   * 审核通过
   */
  Success: 1,
  /**
   * 已拒绝
   */
  Rejected: 2,
  /**
   * 等待提交生成花絮任务
   */
  WaitGenerateHighlightSubmit: 3,
  /**
   * 等待花絮生成完成
   */
  WaitGernerateHighlightDone: 4,

  /**
   * 转码中
   */
  Transcoding: 5
}

export default {
  name: 'AuthorCourseRelevance',
  components: { CourseContainer, AliyunUpload, VideoPlayer },
  data() {
    return {
      highlightDialog: {
        visible: false,
        title: '',
        isPermission: false,
        playInfo: null,
        videoId: '',
        status: 1
      },
      courseDetail: null,
      videoList: [],
      videoCached: [],
      CourseApplyStatus,
      submitApplyLoading: false,
      titleEditing: false,
      applyStatusTextMap: new Map([
        [CourseApplyStatus.Success, '审核通过'],
        [CourseApplyStatus.WaitGenerateHighlightSubmit, '待审核'],
        [CourseApplyStatus.WaitGernerateHighlightDone, '待审核'],
        [CourseApplyStatus.PendingReview, '待审核'],
        [CourseApplyStatus.Rejected, '已拒绝'],
        [CourseApplyStatus.Transcoding, '转码中']
      ]),
      highlightUploading: false
    }
  },
  computed: {
    courseSetId() {
      return this.$route.params.id
    },
    courseUploadKey() {
      return `AUTHOR_COURSE_UPLOAD_KEY_${this.courseSetId}`
    }
  },
  created() {
    this.getCourseSections()
    this.getCourseSectionWithApplies()

    let videoCached = sessionStorage.getItem(this.courseUploadKey)
    if (videoCached) {
      try {
        videoCached = JSON.parse(videoCached)

        // TODO: 临时兼容旧版数据
        if (!Array.isArray(videoCached)) {
          videoCached = []
          sessionStorage.removeItem(this.courseUploadKey)
        }
      } catch (e) {
        console.info(e)
        videoCached = []
        sessionStorage.removeItem(this.courseUploadKey)
      }

      this.videoCached = videoCached
    }
  },
  methods: {
    beforeCloseHandle() {
      this.highlightDialog.visible = false
      this.highlightDialog.status = 0
    },
    async previewAudio(videoId, title) {
      if (
        this.highlightDialog.playInfo &&
        this.highlightDialog.playInfo.videoId === videoId
      ) {
        this.highlightDialog.visible = true
        this.highlightDialog.status = 1
        return
      }
      this.highlightDialog.title = title
      this.highlightDialog.playInfo = {}
      this.highlightDialog.visible = true
      var thisObj = this
      // 添加延迟，等待播放器加载完成
      setTimeout(async () => {
        const detail = await getPlayInfo(videoId)
        thisObj.highlightDialog.playInfo = detail
        thisObj.highlightDialog.playInfo.videoId = videoId
        thisObj.highlightDialog.status = 1
      }, 1000)
    },
    dayjs,
    async getCourseSections() {
      const courseDetail = await getCourseDetail(this.courseSetId)
      if (courseDetail) {
        this.courseDetail = courseDetail
      }
    },
    async getCourseSectionWithApplies() {
      const videoList = await getCourseSectionWithApplies(this.courseSetId)

      this.patchVideoList(videoList)
    },
    patchVideoList(list) {
      const videoCached = this.videoCached

      function patchFirstVideo(index) {
        const found = videoCached.find(item => item.index === index)
        if (found) {
          list.unshift(found)
          patchFirstVideo(index + 1)
        }
      }

      if (videoCached) {
        if (list && list.length) {
          const firstIndex = list[0].index

          for (let i = 0; i < videoCached.length; i++) {
            const foundIndex = list.findIndex(
              item => item.index === videoCached[i].index
            )
            if (foundIndex > -1) {
              if (list[foundIndex].applyStatus === CourseApplyStatus.Rejected) {
                list.splice(foundIndex, 1, {
                  ...list[foundIndex],
                  ...videoCached[i]
                })
              } else {
                this.updateVideoCached(list[foundIndex].index, null)
              }
            }
          }

          patchFirstVideo(firstIndex + 1)
        } else {
          patchFirstVideo(1)
        }
      }

      this.videoList = list
    },
    updateVideoCached(index, cached) {
      const videoCached = this.videoCached
      const currentIndex = videoCached.findIndex(item => item.index === index)
      if (currentIndex > -1) {
        if (cached) {
          videoCached.splice(currentIndex, 1, cached)
        } else {
          videoCached.splice(currentIndex, 1)
        }
      } else if (cached) {
        videoCached.push(cached)
      }
      if (videoCached && videoCached.length) {
        sessionStorage.setItem(
          this.courseUploadKey,
          JSON.stringify(videoCached)
        )
      } else {
        sessionStorage.removeItem(this.courseUploadKey)
      }

      this.videoCached = videoCached
    },
    updateVideoList(index, videoInfo) {
      let currentIndex = this.videoList.findIndex(item => item.index === index)
      if (currentIndex === -1) {
        currentIndex = index
      }
      const result = {
        ...this.videoList[currentIndex],
        ...videoInfo
      }

      this.videoList.splice(currentIndex, 1, result)
      this.updateVideoCached(index, result)
    },
    addVideo() {
      const hasLocalCached = this.videoCached.find(
        item => !isDef(item.applyStatus)
      )

      if (hasLocalCached) {
        this.$alert('请先完成文件上传并提交审核后再添加新的视频', '提示', {
          confirmButtonText: '知道了',
          center: true,
          callback: action => {}
        })
        return
      }

      this.$prompt('请输入视频标题', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        lockScroll: false,
        inputPattern: /^.{1,20}$/,
        inputErrorMessage: '标题不能超过20个字符'
      }).then(({ value }) => {
        let index = 1
        if (this.videoList && this.videoList.length) {
          index = this.videoList[0].index + 1
        }

        const videoInfo = {
          index,
          title: value
        }

        this.videoList.unshift(videoInfo)

        this.updateVideoCached(index, videoInfo)
      })
    },
    editTitle(item) {
      if (
        item.applyStatus !== CourseApplyStatus.PendingReview &&
        item.applyStatus !== CourseApplyStatus.Success &&
        item.applyStatus !== CourseApplyStatus.WaitGenerateHighlightSubmit &&
        item.applyStatus !== CourseApplyStatus.WaitGernerateHighlightDone
      ) {
        this.$prompt('修改视频标题', '标题', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: item.title,
          inputPattern: /^.{1,20}$/,
          center: true,
          inputErrorMessage: '标题不能超过20个字符'
        }).then(({ value }) => {
          item.title = value
        })
      }
    },
    onStartUpload(progress, index, isHighlight) {
      this.updateVideoList(index, {
        [isHighlight ? 'highlightProgressText' : 'progressText']: '',
        [isHighlight ? 'highlightProgress' : 'progress']: ''
      })
    },
    onUploadProgress(progress, index, isHighlight) {
      this.updateVideoList(index, {
        [isHighlight ? 'highlightProgress' : 'progress']: progress
      })
    },
    onUploadComplete(videoInfo, index, isHighlight) {
      let currentVideoInfo
      if (isHighlight) {
        this.highlightUploading = false
        currentVideoInfo = {
          highlightProgressText: '上传成功',
          highlightVideoId: videoInfo.mediaId,
          highlightUploadTime: videoInfo.uploadedTime,
          highlightTitle: videoInfo.title
        }
      } else {
        currentVideoInfo = {
          progressText: '上传成功',
          contentVideoId: videoInfo.mediaId,
          contentUploadTime: videoInfo.uploadedTime,
          contentTitle: videoInfo.title
        }
      }

      this.updateVideoList(index, currentVideoInfo)

      this.getResourceDetail(videoInfo.id, index, isHighlight)
    },
    onUploadCanceled(uploadInfo, index, isHighlight) {
      if (isHighlight) {
        this.highlightUploading = false
      }
      this.updateVideoList(index, {
        [isHighlight ? 'highlightProgressText' : 'progressText']: '已取消'
      })
    },
    onUploadFileChanged(index, isHighlight) {
      let currentVideoInfo
      if (isHighlight) {
        this.highlightUploading = true
        currentVideoInfo = {
          highlightProgressText: '',
          highlightVideoId: '',
          highlightUploadTime: '',
          highlightTitle: '',
          hightlightDuration: 0
        }
      } else {
        currentVideoInfo = {
          progressText: '',
          contentVideoId: '',
          contentUploadTime: '',
          contentTitle: '',
          duration: 0
        }
      }
      this.updateVideoList(index, currentVideoInfo)
    },
    onUploadError(msg) {
      this.$alert(msg, '提示', {
        type: 'warning'
      }).then(() => {})
    },
    async getResourceDetail(id, index, isHighlight) {
      const detail = await getResourceDetail(id)
      if (detail && detail.duration > 0) {
        let videoInfo
        if (isHighlight) {
          videoInfo = {
            hightlightDuration: detail.durationStr,
            isHighlightAvailable: detail.isAvailable // isHighlightAvailable字段名称与getCourseSectionWithApplies接口返回字段名称一致
          }
        } else {
          videoInfo = {
            duration: detail.durationStr,
            isContentAvailable: detail.isAvailable // isContentAvailable字段名称与getCourseSectionWithApplies接口返回字段名称一致
          }
        }
        this.updateVideoList(index, videoInfo)
      }
      if (!detail || !detail.isAvailable) {
        setTimeout(() => {
          this.getResourceDetail(id, index, isHighlight)
        }, 3000)
      }
    },
    async submitApply(index) {
      if (this.submitApplyLoading) return
      this.submitApplyLoading = true
      let currentVideoInfo = null
      if (this.videoCached) {
        currentVideoInfo = this.videoCached.find(item => item.index === index)
      }

      if (!currentVideoInfo) {
        currentVideoInfo = this.videoList.find(item => item.index === index)
      }

      const detail = await submitApply({
        courseSetId: this.courseSetId,
        sectionNo: currentVideoInfo.index,
        contentVideoId: currentVideoInfo.contentVideoId,
        highlightVideoId: currentVideoInfo.highlightVideoId,
        contentUploadTime: currentVideoInfo.contentUploadTime,
        highlightUploadTime: currentVideoInfo.highlightUploadTime,
        sectionName: currentVideoInfo.title
      })

      this.submitApplyLoading = false

      if (detail) {
        this.updateVideoList(currentVideoInfo.index, {
          applyStatus: currentVideoInfo.highlightVideoId
            ? CourseApplyStatus.PendingReview
            : CourseApplyStatus.WaitGenerateHighlightSubmit
        })
        this.updateVideoCached(currentVideoInfo.index, null)
      } else {
        this.$toasted.show('提交审核失败，请重试', {
          position: 'bottom-center',
          duration: 3000
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 30px 0;
}

.input-title-label {
  color: #046bcc;
  cursor: pointer;
}

.input-title {
  display: inline-block;
  width: 100%;
  border: none;
  text-align: center;
  overflow: auto;
  box-sizing: border-box;
  resize: none;
  line-height: 20px;
  padding: 5px;
  height: 100%;

  &:focus {
    outline: none;
  }
}

.course-detail {
  display: flex;
  min-height: 190px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 20px;

  .cover {
    width: 160px;
    height: 120px;
    margin-right: 20px;
    background: no-repeat center;
    background-size: cover;
  }

  .course-title {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 1px;
    color: #262626;
  }

  .course-author {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 1px;
    color: #858585;
  }

  .course-count {
    display: inline-block;
    width: 60px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: rgba(#046bcc, 0.1);
    border-radius: 12px;
    margin-left: 20px;
    font-size: 14px;
    color: #046bcc;
  }

  .course-description {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 1px;
    color: #858585;
  }
}

.video-list {
  padding: 30px 0;
}

.video-row,
.video-row-title {
  width: 766px;
  display: flex;
  text-align: center;

  .video-col {
    width: 0;
    flex: auto;
  }

  .video-col1 {
    flex: 0 0 60px;
  }

  .video-col2 {
    flex: 0 0 120px;
  }

  .video-col3 {
    flex: 0 0 50px;
  }
}

.video-row {
  position: relative;
  font-size: 12px;
  color: #262626;
  height: 120px;
  border: 1px solid #ebebeb;
  margin: 24px 0 80px;
  line-height: 18px;

  .video-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:nth-child(n + 2) {
      border-left: 1px solid #ebebeb;
    }

    .video-col_item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 0;
      flex: auto;
      .video-col_item-p {
        cursor: pointer;
        color: #046bcc;
      }
    }

    .video-col_item:first-child {
      border-bottom: 1px solid #ebebeb;
    }

    .video-col_item > p {
      position: relative;
      line-height: 1.5em;
      /* 高度为需要显示的行数*行高，比如这里我们显示两行，则为3 */
      height: 3em;
      overflow: hidden;
    }
    .video-col_item > p::after {
      content: '...';
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 0 5px;
      background-color: #fff;
    }
  }

  .video-col1 {
    background-color: #fafafa;
  }

  .video-col7 {
    .video-col_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}

.parting-line {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -60px;
  height: 1px;
  background-color: #ebebeb;
}

.button-apply {
  position: absolute;
  right: 0;
  bottom: -42px;
  width: 80px;
  height: 26px;
  line-height: 24px;
  padding: 0;
}

.upload-progress {
  width: 60px;
  padding: 8px 0;
}

.video-row-title {
  font-size: 14px;
  line-height: 40px;
  background-color: #f0f0f0;
  color: #858585;
}

.button-add {
  width: 100px;
  height: 30px;
  line-height: 28px;
  padding: 0;
}
.upload-require:after {
  content: '*';
  color: red;
}
</style>

<style>
.el-dialog__header {
  padding-top: 5px;
  padding-bottom: 15px;
  border: 1px solid #ebebeb;
}
.el-dialog__body {
  padding: 15px 15px 20px;
}
</style>
